export enum ExportEntityType {
  ORDERS = 'orders',
  TRADES = 'trades',
  POSITIONS = 'positions',
  ONEZERO = 'onezero',
  DEALCODE = 'deal_code',
  USER = 'user',
  FIRM = 'firm',
  ALL = 'all'
}

export enum ExportDefaultDays {
  YESTERDAY = 'YESTERDAY',
  TODAY = 'TODAY',
  LAST3DAYS = 'LAST3DAYS',
  LAST5DAYS = 'LAST5DAYS'
}

export interface Report {
  id: number;
  exportType: string;
  exportStatus: string;
  fileName: string;
  createTime: string;
  updateTime: string;
  requestedBy: string;
}

export enum ReportType {
  DAILY_VOLUME = 'DAILY-VOLUME',
  WEEKLY_SPREADS = 'WEEKLY-SPREADS',
  CLIENT_MARGIN = 'CLIENT-MARGIN',
  FILL_RATE_BY_DC = 'FILL-RATE-BY-DEALCODE',
  USD_VOLUME_AND_REV = 'USD-VOLUME-AND-REV',
  CLIENT_VOLUME_SYMBOL = 'CLIENT-VOLUME-SYMBOL',
  SYMBOL_VOLUME = 'SYMBOL-VOLUME',
  PRICE_IMPROVEMENT = 'PRICE-IMPROVEMENT',
  TOP_SELLERS = 'TOP-SELLERS'
}